import { MaybePromise } from 'component_utils/utils';
import { OnEnterArgs, State } from '..';

interface EventProps {}

interface Config<S, P, A, R> {
  nextState: number;
  onEnter: (args: OnEnterArgs<S, P, R>) => MaybePromise<any>;
  noRollback?: boolean;
}

const StateDo = function <S, P extends EventProps, A extends {}, R>({
  nextState,
  onEnter,
  noRollback = false
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      await onEnter(args);
      return {
        type: 'MOVE',
        nextState: nextState,
        noRollback: noRollback
      };
    },

    nodeName: 'T.states.do',
    outputs: [
      {
        name: 'after',
        to: nextState,
      },
    ],
  };
};

export default StateDo;
